import { useEffect, useState } from 'react';
import { ASCII_FACES } from '@/lib/constants/ascii';

export function LoadingScreen() {
  const [face, setFace] = useState('');
  const [show, setShow] = useState(true);

  useEffect(() => {
    const randomFace = ASCII_FACES[Math.floor(Math.random() * ASCII_FACES.length)];
    setFace(randomFace);
    
    // Ensure loading screen shows for at least 1 second
    const timer = setTimeout(() => {
      setShow(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="p-4 text-4xl font-light animate-pulse-soft text-ascii">{face}</div>
    </div>
  );
} 